import { useCallback } from 'react';
import { useReduxForm } from '@rainbow-modules/hooks';
import { CheckboxGroupProps } from 'react-rainbow-components/components/CheckboxGroup';
import CheckBoxGroupFilter, { CheckBoxGroupFilterLabel } from 'components/CheckBoxGroupFilter';

interface Params extends Omit<CheckboxGroupProps, 'value' | 'onChange'> {
    value?: string[] | null;
    onChange?: (values: string[] | null) => void;
}

const callTypes: Record<string, string>[] = [
    { label: 'Inbound', value: 'inbound' },
    { label: 'Outbound', value: 'outbound' },
];

const CallTypeFilter = (props: Params) => {
    const {
        value: valueInProps,
        onChange = () => {},
        ...rest
    } = useReduxForm(props);

    const options = callTypes.map(
        (callType) => ({
            value: callType.value,
            label: <CheckBoxGroupFilterLabel>{callType.label}</CheckBoxGroupFilterLabel>,
        }),
    );

    const value = valueInProps ?? [];

    const handleOnChange = useCallback(
        (values: string[]) => {
            if (!values?.length) return onChange(null);
            return onChange(values);
        },
        [onChange],
    );

    return (
        <CheckBoxGroupFilter
            {...rest}
            hideLabel
            options={options}
            value={value}
            onChange={handleOnChange}
        />
    );
};

export default CallTypeFilter;
